/* eslint-disable max-len */
import React, { useState ,useContext} from 'react'
import AnimatedDeviceList from '../../../../components/Animation/AnimatedDeviceList'
import AnimatedButton from '../../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { toggleRowSelection } from '../../../../redux/MultiselectRowsConditionally'
import moment from 'moment'
import { resetArrays } from '../../../../redux/MultiselectRowsConditionally'
import { useDeviceStatusChangeMutation } from '../../../../features/deviceSlice'
import GlobalContext from '../../../../components/Context/GloablContext'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import { handleEditMessageSent } from '../../../../redux/systemConfigSlice'
const TableBody = ({ tableData,
    isPatient,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setSelectedRow,
    setIsAnyFieldFilled,
    handleDelete,loading,setLoading}) => {
    const { setToastmessage,setToastErrorMessage ,sendMessageToStartEditing,receiveMessageFromSocket,editSocket} = useContext(GlobalContext);
    const navigate = useNavigate()
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    const dispatch = useDispatch()
    const [statusChange] = useDeviceStatusChangeMutation()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams, setSearchParams] = useSearchParams({})
    const selectedRows = useSelector(state => state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [changeStatusModel, setChangeStatusModel] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('')
    const [textAreaMsg, setTextAreaMsg] = useState('')
    // const [loading, setLoading] = useState(false)
    const [emptyField, setEmptyField] = useState(false);
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
   

    const handelActionButton = async (indexNum) => {
        setSelectedIndex(indexNum)
    }

    const handleCheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        dispatch(toggleRowSelection([tableData?.device_id, pageNumber.toString(), List.data, tableData?.status]))
    };


    // for active retired status images
    const handleDevicestatus = (key) => {
        let val = {}
        switch (tableData?.status) {
        case "active":
            val = { img:"active_list_img.svg", text : "Active"}
            break;
        case "out-of-service":
            val = {  img:"outserviceicon.svg", text : "Out of Service"}
            break;
        case "retired":
            val = {img:"retiredicon.svg", text : "Retired" }
            break;

        default:
            break;
        }
        return val[key];

    }
    // status 
    function transformStatusWord(item){
        if (item === 'out-of-service') {
            return 'out of service';
        } else if (item === 'retired'){
            return 'retired';
        }    
        return item;


    }
    function transformWords(item) {
        // Add your transformation logic here
        if (item === 'active') {
            return 'Activate';
        } else if (item === 'out-of-service') {
            return 'Out of Service';
        } else if (item === 'retired'){
            return 'Retire';
        }   
        return item;
    }
    const handleStatusCloseChangeModal = (value) => {
        setSelectedStatus('');
        setTextAreaMsg("")
        setConfirmationState({});
        setChangeStatusModel(false) 
    }

    
    const handleStatusChangeModal = (value) => {
        setSelectedStatus(value);
        setChangeStatusModel(true) 
    }

    const handleStatusChangesingle = async() => {    
        if((textAreaMsg.trim()=== '')){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        const filteredRows = selectedRows.filter(item => item.status !== selectedStatus);
        let body = {
            "device_id": [tableData.device_id],
            "status": selectedStatus,
            "note": textAreaMsg,
        };
        setLoading(true)
        const response = await statusChange({body})
        if(response?.error) {
            setToastErrorMessage(response.error.data.message)
            setChangeStatusModel(false)
            setLoading(false)
        } else{
            if (selectedStatus === 'active') {
                setToastmessage(`Device activated successfully`);
            } else {
                setToastmessage(`Device status changed to ${transformStatusWord(selectedStatus)} successfully`);
            }
            setChangeStatusModel(false)
            setLoading(false)
        }
        setTextAreaMsg('');
        dispatch(resetArrays())
    }
    
    const upatedDate=convertEpochToDateFormat(tableData?.created_at,dateformat)
    // const upatedDate = parseAndFormatDate(tableData?.created_at, dateformat);

    // purchase date conversion
    const formatDate = (dateString) => {
        if (!dateString) return "-";
      
        const formattedDate = new Date(dateString).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        });
      
        return formattedDate;
    };

    const formattedPurchaseDate = formatDate(tableData?.purchase_date);
    const formattedServiceActivationDate = formatDate(tableData?.service_activation_date);

    const handleDeleteItem = () => {
        handleDelete(tableData.device_id)
    }
    
    const assigned = dateformat?.includes('AM/PM') ? moment(tableData?.assigned_at)?.utcOffset('+05:30').format(`${dateformat.split(',')[0]} hh:mm:ss A`) : moment(tableData?.assigned_at)?.format(dateformat)
    return (
        <>
            <AnimatedDeviceList
                id={tableData?.device_id}
                rowStatus={tableData?.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e) => {
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        isPatient===undefined?navigate(`/manage-devices/${tableData?._id}`, { state: Array.isArray(location.state) ? '' : { "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), "search_mode":searchParams.get("search_mode"),'search': searchParams.get("search") ? searchParams.get("search") : '' } }):''
                    }
                }}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start prevent-click  font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            <div className="relative checkbox custom-checkBoxBlue1 provider-tbody">
                                <input type="checkbox" id={isPatient===undefined?tableData.device_id:`item${indexNum}`} checked={selectedRows?.some((obj) => obj?.id === tableData?.device_id) ? true : false} onChange={() => handleCheckboxChange()} className='prevent-click' />
                                <label htmlFor={isPatient===undefined?tableData.device_id:`item${indexNum}`} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click"></label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.device_id}</td>
                        <td className="px-[18px] py-2">
                            <div className="flex items-center justify-start">
                                <img loading="lazy" decoding="async" src={`/images/${handleDevicestatus("img")}`} alt="icon" /> 
                                <span id="status" className={`text-sm rounded-[24px] py-1.5 px-2 w-fit font-normal`}>
                                    {handleDevicestatus("text")}</span>
                                
                            </div>
                        </td>
                        {isPatient===undefined?<td className="px-[18px] py-2 text-sm text-start capitalize font-normal text-[#031624]">{[tableData?.reading_type] &&
                            typeof tableData?.reading_type === 'string'
                            ? tableData?.reading_type.replace(/[_-]/g, " ")
                            : ([tableData?.reading_type] || '').toString().replace(/[_-]/g, " ").replace(/,/g, ", ")
                        }</td>:<td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.serial_number}</td>}
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.manufacturer_name=== "" ? "-" :tableData?.manufacturer_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.model=== "" ? "-" :tableData?.model}</td>
                        {isPatient===undefined?<td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.serial_number}</td>:<td className="px-[18px] py-2 text-sm text-start capitalize font-normal text-[#031624]">{[tableData?.reading_type] &&
                            typeof tableData?.reading_type === 'string'
                            ? tableData?.reading_type.replace(/[_-]/g, " ")
                            : ([tableData?.reading_type] || '').toString().replace(/[_-]/g, " ").replace(/,/g, ",")
                        }</td>}
                        {isPatient===undefined&&<td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id=== "" ? "-" :tableData?.patient_id}</td>}
                        {isPatient===undefined&&<td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.assigned_at=== "" || tableData?.assigned_at===null || tableData?.assigned_at===undefined) ? "-" :convertEpochToDateFormat(tableData?.assigned_at,dateformat)}</td>}
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{formattedPurchaseDate}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.service_provider=== "" ? "-" :tableData?.service_provider}</td>
                        <td className="px-[9px] py-2 text-start text-sm  font-normal text-[#031624]">{tableData?.service_period=== "" ? "-" :tableData?.service_period}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{formattedServiceActivationDate}</td>
                        <td className="px-[9px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.warranty_period=== "" ? "-" :tableData?.warranty_period}</td>
                        {isPatient===undefined&&<td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.initial_reading_timestamp=== "" || tableData?.initial_reading_timestamp===undefined || tableData?.initial_reading_timestamp===null )? "-":convertEpochToDateFormat(tableData?.initial_reading_timestamp,dateformat)}</td>}
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]"> <div className="line-clamp-2">
                            {tableData?.description === "" ? "-" : tableData?.description}
                        </div></td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{upatedDate}</td>
                        {isPatient===undefined&&<td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.some(item => item.id === tableData.device_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <div className="relative flex items-center justify-center" data-te-dropdown-ref>
                                <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click"
                                    id={"id"}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() => handelActionButton(indexNum)}
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    data-testid="action-bar"
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                </button>
                                {selectedIndex === indexNum && <ul style={{marginRight:'2px'}} ref={selectedRef} className={`border border-[#C2DCEF] px-5 py-2.5 absolute z-[99] float-left m-0  ${lastIndex === indexNum + 1 ? ' top-[0px]' : ' top-0'} right-[68px] min-w-[200px] list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { }}
                                            buttonName={"View"}
                                            locnState={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"),'search_mode':searchParams.get("search_mode"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}
                                            link={`/manage-devices/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => {
                                                if(!messageSent){
                                                   
                                                    sendMessageToStartEditing(tableData?.device_id)
                                                    let message
                                                    editSocket.onmessage = (event) =>{
                                                        message = event.data

                                                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                                                          
                                                            navigate(`/manage-devices/edit-device/${tableData._id}`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),'search_mode':searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}})
                                                        } else{
                                                            dispatch(handleEditMessageSent(false))
                                                            
                                                            { (JSON.parse(message)?.adminId) &&
                                                                setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this device`)
                                                            }
                                                        }
                                                    }    
                                                }
                                                
                                            }}
                                            buttonName={"Edit"}
                                            locnState={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}
                                            // link={`/manage-devices/edit-device/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    {tableData.status!=='active'&&
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => { handleStatusChangeModal('active')}}
                                            buttonName={'Activate'}
                                          
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    }
                                    {tableData.status!=='retired'&&
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => { handleStatusChangeModal('retired') }}
                                            buttonName={`Retire`}
                                         
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    }
                                    {tableData.status!=='out-of-service'&&
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { handleStatusChangeModal('out-of-service') }}
                                            buttonName={`Out of Service`}
                                           
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    }
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => { setIsDeleteOpen(true) }}
                                            buttonName={`Delete`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <div className='absolute top-[12px] right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0'>

                                    </div>
                                </ul>}

                            </div>
                        </td>}
                    </>

                } />
            {isDeleteOpen &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleDeleteItem}
                        handleClose={() => setIsDeleteOpen(false)}
                        tittle= {'Delete'}
                        message = {`Are you sure you want to delete this device?`}
                        buttonName = {"Yes"}
                        loadingActivation={loading}
                        CancelButton = {"No"}
                        disabled={loading}
                    />
                }
            />
            }
            {changeStatusModel && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt
                        emptyField={emptyField}
                        setEmptyField={setEmptyField}
                        setTextAreaMsg={setTextAreaMsg}
                        textAreaMsg={textAreaMsg}
                        handleOnCLickActivate={handleStatusChangesingle}
                        handleClose={handleStatusCloseChangeModal}
                        tittle= {transformWords(selectedStatus)}
                        message = {selectedStatus=== "active" ? `Are you sure you want activate this device?` :`Are you sure you want to change the status of this device to ${transformStatusWord(selectedStatus)}?`}
                        // textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                        buttonName = {'Yes'}
                        loadingActivation={loading}
                        CancelButton={'No'}
                        disabled={loading}
                    />
                }
            /> 
            }
        </>
    )
}

export default TableBody